/**
 *
 * RoomPickerFilter
 *
 */
import { RoomPicker } from 'app/components/pickers/AutocompletePickers/RoomPicker';
import * as React from 'react';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { Entity } from 'types/common';
import { IFilterComponentProps } from '../IFilterComponentProps';

export const RoomPickerFilter = (props: IFilterComponentProps) => {
  const handleOnChange = (value: Entity<number> | null) => {
    props.onChange(value);
  };
  const { t } = useTranslation();
  return (
    <RoomPicker
      onChange={handleOnChange}
      value={props.value}
      isOpen={props.open}
      size="small"
      placeholder={t(translations.AllValues)}
      ariaLabel={props.label}
      id={props.id}
      predicates={props.predicates}
      onPickerOpen={props.onOpen}
      urlType={props.urlType}
    />
  );
};
export default RoomPickerFilter;
